import { useEffect, useState } from 'react'
import { useTranslation } from '@mc/i18n'
import { BrandKey } from '../../../utils'
import { GladlyBreadcrumbs } from '../GladlyBreadcrumbs'
import { GladlySearchBox } from '../GladlySearch'
import classes from './GladlyProductHubHeader.module.scss'

interface GladlyProductHubHeaderProps {
  brandKey: BrandKey
  answerName?: string
}

export const GladlyProductHubHeader = ({
  brandKey,
  answerName,
}: GladlyProductHubHeaderProps) => {
  const { t } = useTranslation('@mc/next')
  const I18N_PREFIX = `helpCenter.${brandKey}`
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={`position-sticky ${classes.header}`}>
      <GladlyBreadcrumbs brandKey={brandKey} answerName={answerName} />
      <div
        className={`mc-theme-dark mc-bg-dark mc-w-100 mc-text--center mc-pt-6 mc-pb-4 mc-pb-md-9 ${classes.headerContent} ${scrolled ? classes.scrolled : ''}`}
      >
        <div className='container position-relative mc-px-4'>
          <h1 className='mc-text-h1 mc-mx-auto'>{t(`${I18N_PREFIX}.title`)}</h1>
          <p className='mc-mx-auto mc-opacity--hinted'>
            {t(`${I18N_PREFIX}.description`)}
          </p>
          <div
            className={`mc-mt-8 ${classes.searchBoxContainer} ${scrolled ? classes.scrolledSeachBoxContainer : ''}`}
          >
            <GladlySearchBox brandKey={brandKey} />
          </div>
        </div>
      </div>
    </div>
  )
}
